<template>
  <div class="format-change-wrapper">
    <div class="flex w-full" style="justify-content: space-between">
      <div class="flex flex-col">
        <h6 class="format-change-header">自定义模板样式</h6>
        <!-- 基本信息 -->
        <div class="format-change-item">
          <h6 class="format-change-item-title">基本信息</h6>
          <div class="format-change-item-list">
            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持文字样式"
              :disabled="cvDetail.format_info.top_format !== 'left_block'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[profile.show_attr_name === 1 ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'left_block'"
                @click="
                  setFormatInfo({ template_type: null });
                  selectInfo(1);
                "
              >
                <i class="buttonicon iconfont iconwenzi"></i>
                <span>文字</span>
              </button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持图标样式"
              :disabled="cvDetail.format_info.top_format !== 'left_block'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[profile.show_attr_name === 2 ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'left_block'"
                @click="
                  setFormatInfo({ template_type: null });
                  selectInfo(2);
                "
              >
                <i class="buttonicon iconfont icontubiao"></i>
                <span>图标</span>
                <img
                  class="vip-icon"
                  src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
                  alt=""
                />
              </button>
            </el-tooltip>
            <button
              :class="[profile.show_attr_name === 0 ? 'action' : '']"
              @click="
                setFormatInfo({ template_type: null });
                selectInfo(0);
              "
            >
              <i class="buttonicon iconfont iconjianjie"></i>
              <span>简洁</span>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                alt=""
              />
            </button>
          </div>
        </div>

        <!-- 基本信息颜色 -->
        <div class="format-change-item">
          <h6 class="format-change-item-title">信息颜色</h6>
          <div class="flex items-center">
            <div class="format-change-item-list bg-color normal-vip">
              <div
                :class="[
                  'theme',
                  `theme-${index}`,
                  cvDetail.format_info.profile_color === item &&
                  !cvDetail.format_info.profile_select_color
                    ? 'action'
                    : '',
                ]"
                v-for="(item, index) in THEME"
                :key="item"
                :style="{ background: item }"
                @click="
                  setFormatInfo({
                    profile_select_color: false,
                    profile_color: item,
                  })
                "
              >
                <i class="iconfont iconcheck"></i>
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                alt=""
              />
            </div>
            <div class="format-change-item-list bg-color wonder-vip">
              <div
                :class="[
                  'theme',
                  'theme-select',
                  cvDetail.format_info.profile_select_color ? 'action' : '',
                ]"
                @click.stop
              >
                <i class="iconfont iconcheck"></i>
                <input
                  type="color"
                  v-model="cvDetail.format_info.profile_color"
                  @input="
                    setFormatInfo({
                      profile_select_color: true,
                      profile_color: cvDetail.format_info.profile_color,
                    })
                  "
                />
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 布局 -->
        <div class="format-change-item">
          <h6 class="format-change-item-title">头部布局</h6>
          <div class="format-change-item-list">
            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持居左布局"
              :disabled="cvDetail.format_info.top_format !== 'circle'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.head_format === 'left' ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'circle'"
                @click="setFormatInfo({ head_format: 'left', template_type: null })"
              >
                <i class="buttonicon iconfont iconjuzuo"></i>
                <span>居左</span>
              </button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持居中布局"
              :disabled="!['circle', 'left_block'].includes(cvDetail.format_info.top_format)"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.head_format === 'center' ? 'action' : '']"
                :disabled="['circle', 'left_block'].includes(cvDetail.format_info.top_format)"
                @click="setFormatInfo({ head_format: 'center', template_type: null })"
              >
                <i class="buttonicon iconfont iconjuzhong"></i>
                <span>居中</span>
                <img
                  class="vip-icon"
                  src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                  alt=""
                />
              </button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持商务布局"
              :disabled="!['left_block'].includes(cvDetail.format_info.top_format)"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.head_format === 'body_center' ? 'action' : '']"
                :disabled="['left_block'].includes(cvDetail.format_info.top_format)"
                @click="
                  setFormatInfo({
                    head_format: 'body_center',
                    template_type: null,
                  })
                "
              >
                <i class="buttonicon iconfont icondatouxiang"></i>
                <span>商务</span>
                <img
                  class="vip-icon"
                  src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
                  alt=""
                />
              </button>
            </el-tooltip>
          </div>
        </div>

        <!-- 顶部 -->
        <div class="format-change-item" style="align-items: flex-start">
          <h6 class="format-change-item-title">纸张样式</h6>
          <div class="format-change-item-list">
            <button
              v-for="(item, index) in LETTER_DATA"
              :key="index"
              :class="[cvDetail.format_info.top_format === item.value ? 'action' : '']"
              @click="setCvHeaderLineShow(item.value, item.vip, false)"
            >
              <i :class="`buttonicon iconfont ${item.icon}`"></i>
              <span>{{ item.letter }}</span>
              <img
                v-if="item.vip"
                class="vip-icon"
                :src="
                  item.vip === 'normal'
                    ? 'https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg'
                    : 'https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg'
                "
                alt=""
              />
            </button>
          </div>
        </div>

        <div
          v-show="
            ['line', 'block', 'circle', 'left_block'].includes(cvDetail.format_info.top_format)
          "
          class="flex items-center"
          style="margin-bottom: 16px; padding-left: 84px"
        >
          <div class="top-line-color-select format-change-item-list bg-color normal-vip">
            <div
              :class="[
                'theme-header-line',
                'theme',
                `theme-${index}`,
                cvDetail.format_info.top_line_color === item &&
                !cvDetail.format_info.top_line_select_color
                  ? 'action'
                  : '',
              ]"
              v-for="(item, index) in HEADER_LINE_THEME"
              :key="item"
              :style="{ background: item }"
              @click="
                setFormatInfo({
                  top_line_select_color: false,
                  top_line_color: item,
                })
              "
            >
              <i class="iconfont iconcheck"></i>
            </div>
            <img
              class="vip-icon"
              src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
              alt=""
            />
          </div>
          <div class="top-line-color-select format-change-item-list bg-color wonder-vip">
            <div
              :class="[
                'theme',
                'theme-select',
                cvDetail.format_info.top_line_select_color ? 'action' : '',
              ]"
              @click.stop
            >
              <i class="iconfont iconcheck"></i>
              <input
                type="color"
                v-model="cvDetail.format_info.top_line_color"
                @input="
                  setFormatInfo({
                    top_line_select_color: true,
                    top_line_color: cvDetail.format_info.top_line_color,
                  })
                "
              />
            </div>
            <img
              class="vip-icon"
              src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
              alt=""
            />
          </div>
        </div>

        <!-- 标题样式 -->
        <div class="format-change-item title-format">
          <h6 class="format-change-item-title">标题样式</h6>
          <div class="format-change-item-list">
            <button
              :class="[cvDetail.format_info.title_format === 'default' ? 'action' : '']"
              @click="changeTileFormat('default', false)"
            >
              <i class="buttonicon iconfont iconzhuanye"></i>
              <span>通用</span>
            </button>

            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持专业样式"
              :disabled="cvDetail.format_info.top_format !== 'left_form'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.title_format === 'strip' ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'left_form'"
                @click="changeTileFormat('strip', false)"
              >
                <i class="buttonicon iconfont iconqingxin"></i>
                <span>专业</span>
                <img class="vip-icon" src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg" alt="" />
              </button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持突出样式"
              :disabled="cvDetail.format_info.top_format !== 'left_form'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.title_format === 'tag' ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'left_form'"
                @click="changeTileFormat('tag', false)"
              >
                <i class="buttonicon iconfont icontuchu"></i>
                <span>突出</span>
                <img class="vip-icon" src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg" alt="" />
              </button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="该模版不支持简约样式"
              :disabled="cvDetail.format_info.top_format !== 'left_form'"
              popper-class="module-popper"
              placement="bottom-end"
            >
              <button
                :class="[cvDetail.format_info.title_format === 'icon' ? 'action' : '']"
                :disabled="cvDetail.format_info.top_format === 'left_form'"
                @click="changeTileFormat('icon', false)"
              >
                <i class="buttonicon iconfont icontubiao1"></i>
                <span>简约</span>
                <img class="vip-icon" src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg" alt="" />
              </button>
            </el-tooltip>
          </div>
        </div>

        <!-- 主题色选择 -->
        <div class="format-change-item title-format">
          <h6 class="format-change-item-title">标题颜色</h6>
          <div class="flex items-center">
            <div class="format-change-item-list bg-color normal-vip">
              <div
                :class="[
                  'theme',
                  `theme-${index}`,
                  cvDetail.format_info.title_color === item &&
                  !cvDetail.format_info.title_select_color
                    ? 'action'
                    : '',
                ]"
                v-for="(item, index) in THEME"
                :key="item"
                :style="{ background: item }"
                @click="setFormatInfo({ title_select_color: false, title_color: item })"
              >
                <i class="iconfont iconcheck"></i>
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                alt=""
              />
            </div>
            <div
              v-show="cvDetail.format_info.title_format !== 'icon'"
              class="format-change-item-list bg-color wonder-vip"
            >
              <div
                :class="[
                  'theme',
                  'theme-select',
                  cvDetail.format_info.title_select_color ? 'action' : '',
                ]"
                @click.stop
              >
                <i class="iconfont iconcheck"></i>
                <input
                  type="color"
                  v-model="cvDetail.format_info.title_color"
                  @input="
                    setFormatInfo({
                      title_select_color: true,
                      title_color: cvDetail.format_info.title_color,
                    })
                  "
                />
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { HEADER_LINE_THEME, LETTER_DATA, THEME } from '@/assets/js/const';
import { debounce } from '@/assets/js/util';
export default {
  name: 'FormatChange',
  data() {
    return {
      HEADER_LINE_THEME,
      LETTER_DATA,
      THEME,
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'profile']),
  },
  methods: {
    // 切换简历 标题样式（类型）
    changeTileFormat(type) {
      // 如果选择了图标标题，并且这个时候标题颜色选择的自定义颜色，因为图标标题没有自定义颜色选项，所以需要把标题颜色重置为默认值
      if (type === 'icon' && this.cvDetail.format_info.title_select_color) {
        this.setFormatInfo({
          title_select_color: false,
          title_color: '#000000',
          title_format: type,
        });
      } else {
        this.setFormatInfo({ title_format: type, template_type: null });
      }
    },
    //更改format_info
    setFormatInfo: debounce(function (options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
        if (key === 'line_spacing') {
          //保存行距
          this.$store.commit('editor/setOldLineHeight', options[key]);
        }
      });
      this.$store.commit('editor/setCvDetail', cvDetail);

      //触发保存
      this.submit();
    }, 300),
    // 切换是否显示信息名称
    async selectInfo(value) {
      this.profile.show_attr_name = value;
      try {
        //检测是否有profile数据
        if (this.profile.id && typeof this.profile.id === 'number') {
          let res = await this.$store.dispatch('editor/updateProfileData', {
            payload: this.profile,
          });
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message);
          }
        }
      } catch (error) {}
    },
    // 设置 顶部线条 显示
    async setCvHeaderLineShow(type, flag, isTemplateStyle) {
      let format = {
        top_format: type,
      };

      switch (type) {
        case 'left_block':
          format.head_format = 'left';
          format.watermark = '';
          format.page_margin = 5;
          this.selectInfo(0);
          await this.$store.dispatch('editor/updateCvDetail', {
            basic_info: {
              school_logo_url: '',
            },
            operation_type: 'update_basic_info',
            skipCheck: true,
          });
          break;
        case 'left_form':
          format.title_format = 'default';
          format.top_line_color = '#404040';
          format.top_line_select_color = false;
          break;
        case 'default':
          format.top_line_color = '#404040';
          format.top_line_select_color = false;
          break;
        case 'circle':
          format.head_format = 'body_center';
          break;
      }

      if (!isTemplateStyle) format.template_type = null;
      this.setFormatInfo(format);
    },
    // 保存
    async submit() {
      let { kind } = this.cvDetail.basic_info;
      if (kind === 'template' || kind === 'sample') return;
      this.$emit('changeSaveLoading', true);
      try {
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info,
          skipCheck: true,
        });
        if (res.code === 1000) {
          // this.$message.success('保存成功');
        } else {
          this.$message.success(res.message);
        }
      } catch (error) {
        this.$message.success('修改失败');
      } finally {
        this.$emit('changeSaveLoading', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.format-change-wrapper {
  position: absolute;
  top: 36px;
  right: 0;
  width: 448px;
  padding: 20px;
  background-color: #191c20;
  border-radius: 8px;
  border: 1px solid #383e49;
  backdrop-filter: blur(8px);
  box-sizing: border-box;
  .format-change-header {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    width: fit-content;
    img {
      width: 28px;
      margin-left: 6px;
    }
  }
  .format-change-item {
    display: flex;
    margin-bottom: 16px;
    max-width: 380px;
    .format-change-item-title {
      font-size: 14px;
      line-height: 32px;
      font-weight: 500;
      color: #8d99aa;
      margin-right: 28px;
    }
  }
  .format-change-item-list {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: fit-content;

    &.bg-color {
      position: relative;
      align-items: center;
      gap: 10px;
      width: fit-content;
      flex: none;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: -6px;
        right: -6px;
        height: calc(100% + 12px);
        border-radius: 4px;
        background-color: #212529;
        z-index: 1;
      }
      .theme {
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 2px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: none;
        z-index: 2;
        &:hover {
          transform: scale(1.1);
        }

        &.theme-select {
          overflow: hidden;
          position: relative;
          background: url('https://files.wondercv.com/PC/editor/Color_finder.png') no-repeat
            center/cover;
          &::after {
            display: none;
          }
          input[type='color'] {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 3;
            width: 100%;
            height: 34px;
            opacity: 0;
            cursor: pointer;
          }
        }

        &::after {
          content: '';
          position: absolute;
          z-index: 1;
          left: 50%;
          bottom: 0px;
          transform: translateX(-50%);
          width: 18px;
          height: 18px;
          opacity: 1;
          border-radius: 50%;
          // background-color: #000000;
          // box-shadow: 0px 6px 16px -4px #000000;
        }

        &.theme-0 {
          margin-right: 6px;
        }

        &.theme-0:hover::after {
          background-color: #000000;
          box-shadow: 0px 6px 16px -4px #000000;
        }

        &.theme-0.theme-header-line::after {
          background-color: #404040;
          box-shadow: 0px 6px 16px -4px #404040;
        }

        &.theme-1:hover::after {
          background-color: #ca3832;
          box-shadow: 0px 6px 16px -4px #ca3832;
        }

        &.theme-2:hover::after {
          background-color: #ee8732;
          box-shadow: 0px 6px 16px -4px #ee8732;
        }

        &.theme-3:hover::after {
          background-color: #4183ff;
          box-shadow: 0px 6px 16px -4px #4183ff;
        }

        &.theme-4:hover::after {
          background-color: #9c5bde;
          box-shadow: 0px 6px 16px -4px #9c5bde;
        }

        &.theme-5:hover::after {
          background-color: #6db557;
          box-shadow: 0px 6px 16px -4px #6db557;
        }

        .iconfont {
          display: none;
          color: #ffffff;
          font-size: 16px;
          margin-top: 2px;
          font-weight: 600;
          z-index: 2;
        }

        &.action {
          .iconfont {
            display: block;
          }
        }
      }
      .vip-icon {
        position: absolute;
        width: 16px;
        height: 16px;
        top: -10px;
        right: -10px;
        z-index: 3;
      }
    }

    &.normal-vip::before {
      width: 152px;
    }
    &.wonder-vip {
      margin-left: 22px;
      &::before {
        width: 32px;
      }
    }

    > button {
      position: relative;
      width: 88px;
      height: 32px;
      box-sizing: border-box;
      background: #212529;
      border-radius: 4px;
      border: 1px solid #212529;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      &:disabled {
        cursor: not-allowed;
        background: #2d3238;
        color: rgba(255, 255, 255, 0.4);
        border: none;
      }
      > i {
        font-size: 14px;
        margin-right: 4px;
      }
      > span {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
      }
      &.action,
      &:hover:not(:disabled) {
        background: linear-gradient(to right, #383e49, #383e49);
        border: 1px solid #fff;
        > i,
        > span {
          color: #fff;
        }
      }
      .vip-icon {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
